export default {
    'add-a-record': 'إضافة سجل جديد',
    'the-employee-is-balance-is-being-prepared-for-the-day': 'سيتم تهيئة رصيد الموظف لهذا اليوم ',
    'non-matching-records': "السجلات الغير مطابقة",
    "total-amount-received": "إجمالي المبلغ المستلم",
    "total-amount-delivered": "إجمالي المبلغ المُسلَّم",
    "are-you-sure-you-want-to-migrate-this-journal": "؟ هل أنت متأكد أنك تريد ترحيل هذه يومية"
}